/**
 * テクスチャモジュールのエントリーポイント
 * globを使用して全てのテクスチャクラスを自動的に読み込む
 */

// globを使用して全てのテクスチャモジュールを動的にインポート（index.jsを除く）
const textureModules = import.meta.glob('./*Texture.js', { eager: true });

// 全てのテクスチャクラスを含むオブジェクト
const textures = {};

// 全てのテクスチャクラスを抽出してエクスポート用オブジェクトに追加
Object.entries(textureModules).forEach(([path, module]) => {
    if (module && typeof module === 'object') {
        Object.entries(module).forEach(([exportName, exportedItem]) => {
            if (exportedItem && 
                typeof exportedItem === 'function' && 
                (exportedItem.createAll || exportedItem.create)) {
                textures[exportName] = exportedItem;
            }
        });
    }
});

// 全てのテクスチャクラスをエクスポート
export const Textures = textures;

/**
 * 全てのテクスチャを生成する
 * @param {Phaser.Scene} scene - テクスチャを生成するシーン
 * @returns {Promise<boolean>} テクスチャ生成の成否を返すPromise
 */
export async function createAllTextures(scene) {
    try {
        console.log('Textures: テクスチャの生成を開始します');
        
        // 全てのテクスチャクラスを取得
        const textureClasses = Object.values(textures);
        
        // 各テクスチャクラスのcreateAllまたはcreateメソッドを呼び出す
        for (const TextureClass of textureClasses) {
            // createAllメソッドがある場合はそれを優先、なければcreateメソッドを呼び出す
            TextureClass.createAll?.(scene) || TextureClass.create?.(scene);
        }
        
        console.log('Textures: 全てのテクスチャを生成しました');
        return true;
    } catch (error) {
        console.error('Textures: テクスチャの生成中にエラーが発生しました', error);
        return false;
    }
}
